import { Http } from '../../shared';
import { settings } from '../../settings';

export class SettingService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }


    async find(query) {
        var response = await this.http.get(`${this.service_url}/settings?${new URLSearchParams(query)}`);
        return response.data;
    }
}
